//UNCOMMENT ON BUILD
export const API = "https://api.harnic.id"
export const APIV3 = "https://api3.harnic.id/v3"
export const version = 999

//ONLY FOR DEBUG
// export const API = "https://cors-anywhere.herokuapp.com/https://api.harnic.id";
